import { FETCH_SEATINGS_SUCCESS, FETCH_SEATINGS_ERROR, FETCH_SEATINGS } from './constants';

const poolingInitialState = {
  isFetching: false,
  isFree: {},
};

const poolingReducer = (state = poolingInitialState, action) => {
  switch (action.type) {
    case FETCH_SEATINGS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFree: {
          ...state.isFree,
          [action.idDps]: action.payload,
        },
      };
    case FETCH_SEATINGS_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case FETCH_SEATINGS:
      return {
        ...state,
        isFetching: true,
      };
    default:
      return state;
  }
};

export default poolingReducer;



// WEBPACK FOOTER //
// ./src/containers/Pooling/reducer.js